import { Lock } from 'lucide-react';
import type { UpsellPaymentBranding } from '../api/paymentApi';

/** Pied de page : mentions du garant (raison sociale, SIREN, adresse) quand elles sont connues. */
export function PaymentFooter({ branding }: { branding: UpsellPaymentBranding | null }) {
  const cityLine = branding ? [branding.cp, branding.city].filter(Boolean).join(' ') : '';
  const address = branding ? [branding.address, cityLine].filter(Boolean).join(', ') : '';
  const legalParts = branding
    ? [branding.legalName || branding.name, branding.siren ? `SIREN ${branding.siren}` : null, address || null].filter(
        (part): part is string => Boolean(part),
      )
    : [];

  return (
    <footer className="tw-border-t tw-border-slate-200 tw-bg-white">
      <div className="tw-mx-auto tw-flex tw-max-w-6xl tw-flex-col tw-gap-2 tw-px-4 tw-py-6 tw-text-xs tw-text-gray-600 sm:tw-flex-row sm:tw-items-center sm:tw-justify-between sm:tw-px-6">
        {legalParts.length > 0 ? <p className="tw-mb-0">{legalParts.join(' · ')}</p> : <span />}
        <p className="tw-mb-0 tw-inline-flex tw-items-center tw-gap-1.5">
          <Lock className="tw-h-3.5 tw-w-3.5" aria-hidden="true" />
          Paiement sécurisé opéré par Stripe
        </p>
      </div>
    </footer>
  );
}
